import IconTwitter from 'resources/images/icon-twiter.png';
import IconTelegram from 'resources/images/icon-telegram.png';
import IconReddit from 'resources/images/icon4.png';
import IconFB from 'resources/images/icon-fb.png';
//background
import fb from 'resources/images/social-bg-1.png';
import twiter from 'resources/images/social-bg-2.png';
import telegram from 'resources/images/social-bg-3.png';
import reddit from 'resources/images/social-bg-4.png';

const socialLinks = [
  {
    name: 'Twitter',
    icon: IconTwitter,
    bg: twiter,
    link: 'https://twitter.com/ageofgodsnet'
  },
  {
    name: 'Telegram',
    icon: IconTelegram,
    bg: telegram,
    link: 'https://t.me/ageofgodsnet'
  },
  {
    name: 'Discord',
    icon: IconReddit,
    bg: reddit,
    link: 'https://discord.com/invite/JHfrhc6cXE'
  },
  {
    name: 'Facebook',
    icon: IconFB,
    bg: fb,
    link: 'https://www.facebook.com/ageofgodsofficial/'
  }
];

export { socialLinks };
